import { User } from '../../models/user.model';
import * as AdminActions from './admin.actions';

export interface AdminState {
  /**
   * Specifies which student the admin user is currently viewing.
   * Used for viewing student patients in the Patient Dashboard.
   */
  student: User | null;
}

export const adminFeatureKey = 'admin';

export { AdminActions };
